export default __webpack_public_path__ + "static/media/tab03_title03.c22113b3.png";